import { log } from 'log';
import { getBaseDomain } from 'js/utils/url.util';

export const init = () => {
    const domain = getBaseDomain({ dotStart: false });

    log('info', '[UCIP]: Init');

    try {
        document.domain = domain;

        log('info', '[UCIP]: Domain was changed to ', domain);
    } catch (e) {
        log('error', '[UCIP]: Can not change domain to ', domain);
    }
};

export const parseMessage = (event) => {
    try {
        if (event?.data) {
            log('info', '[UCIP]: Receive: ', event.data);

            return JSON.parse(event.data);
        }
    } catch (e) {
        log('warn', '[UCIP]: Post message ca not be parsed: ', event);
    }
};

export const sendMessage = (message) => {
    try {
        const json = JSON.stringify(message);

        document.querySelector('.game-iframe').contentWindow.postMessage(json, '*');

        log('info', '[UCIP]: Sent: ', JSON.stringify(message));
    } catch (e) {
        log('error', '[UCIP]: Post message can not be sent: ', message);
    }
};

export const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

export const onMessage = (event) => {
    log('info', '[UCIP]: ', event);

    const message = parseMessage(event);
    // eslint-disable-next-line no-underscore-dangle
    const type = message?._type;

    if (type === 'ucip.basic.g2wInitializationRequest') {
        const supportedFeatures = message?.features || [];
        const features = [];

        if (supportedFeatures.includes('displaystatus')) {
            features.push('displaystatus');
        }

        sendMessage({
            _type: 'ucip.basic.w2gInitializationResponse',
            version: '1.0.0',
            features
        });
    } else if (type === 'ucip.basic.g2wCloseGameFrameCommand' && !inIframe()) {
        log('info', '[UCIP]: Close game');

        if (window.close) {
            window.close();
        }
    }
};
